import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

export const LikeShareButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  font-size: 16px;
  align-items: center;
  grid-column: 1 / -1;
`;

export const ShareContainer = styled.div`
  width: 100%;
  grid-column: 1 / -1;
  display: flex;
  gap: 10px;
  font-size: 16px;
  align-items: center;
  justify-content: flex-end;

  span {
    margin-right: 3px;
    display: none;

    ${breakpoints.md} {
      display: inherit;
    }
  }
`;
